import React, { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionHeader from 'commons/src/components/headers/SectionHeader';
import SensorIcon from 'commons/src/components/sensors/SensorIcon';
import ThresholdSetting from 'commons/src/components/thresholds/ThresholdSetting';
import { sensorFullNameKey, sensorUnits } from 'commons/src/constants';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { ThresholdRange } from 'commons/src/models/commonTypeScript';
import { CustomOptions, ThresholdOption } from 'commons/src/models/customThresholdModels';
import styles from './SensorThresholdMgmt.module.scss';

export type Props = {
    sensorType: SensorTypes;
    thresholds: {
        customOptions?: CustomOptions;
        ranges: ThresholdRange[];
        unit: keyof typeof sensorUnits;
        thresholdOptions: ThresholdOption[];
    };
    onSave: () => void;
};
const SensorThresholdMgmt = ({ sensorType, thresholds, onSave }: Props): ReactElement => {
    const { t: txt } = useTranslation();
    const [selectedValues, setSelectedValues] = useState<number[]>([]);

    return (
        <div>
            <SectionHeader
                headerType={4}
                headerName={sensorFullNameKey(sensorType)}
                leadingIcon={<SensorIcon sensor={sensorType} />}
            />
            <p className={styles.description}>{txt(`ThresholdSettings.${sensorType}Description`)}</p>
            <ThresholdSetting
                sensorType={sensorType}
                ranges={thresholds.ranges}
                thresholdOptions={thresholds.thresholdOptions}
                customOptions={thresholds.customOptions}
                selectedValues={selectedValues}
                setSelectedValues={setSelectedValues}
                buttonText="ThresholdSettings.UpdateAccountThresholds"
                loading={false}
                onSave={onSave}
            />
        </div>
    );
};

export default SensorThresholdMgmt;
